import sha1Hex from 'crypto-js/sha1';

export const sha1 = (str: string) => {
  const wordArray = sha1Hex(str);
  return wordArray.toString();
};
